import { createSelector } from 'reselect';
//
import {
  getIsMultiBatchClearabee,
  getIsMultiBatchFlowers,
  getIsSingleBatchClearabee,
  getIsSingleBatchFlowers,
} from '../../redux/reducers/delivery/deliverySelector';

export default createSelector(
  [
    getIsSingleBatchClearabee,
    getIsMultiBatchClearabee,
    getIsSingleBatchFlowers,
    getIsMultiBatchFlowers,
  ], (
    isSingleBatchClearabee,
    isMultiBatchClearabee,
    isSingleBatchFlowers,
    isMultiBatchFlowers,
  ) => ({
    isSingleBatchClearabee,
    isMultiBatchClearabee,
    isSingleBatchFlowers,
    isMultiBatchFlowers,
  }),
);
